import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Copyright } from "../Copyright";
import { APP_TITLE } from "../../constants/dashboard";

export function AuthLayout() {
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        height: "100vh",
      }}
    >
      <Container maxWidth="xs" sx={{ height: "80vh" }}>
        <Stack
          spacing={2}
          sx={{
            height: "80vh",
            p: 2,
            overflow: "auto",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            sx={{
              mb: 2,
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            {APP_TITLE.TITLE} 
          </Typography>
          <Paper elevation={2} sx={{ p: 4 }}>
            <Outlet />
          </Paper>
          <Copyright />
        </Stack>
      </Container>
    </Box>
  );
}
